import {EventEmitter, Injectable} from "@angular/core";

@Injectable()
export class HttpEventService {
	onServerError: EventEmitter<any> = new EventEmitter<any>();
	onNameExistError: EventEmitter<any> = new EventEmitter<any>();
	onTenantMappingExistError: EventEmitter<any> = new EventEmitter<any>();
	onInterfaceCodeExistError: EventEmitter<any> = new EventEmitter<any>();
	onFileDownloadError: EventEmitter<any> = new EventEmitter<any>();
	onFileUploadError: EventEmitter<any> = new EventEmitter<any>();
	onDuplicateFileContentError: EventEmitter<any> = new EventEmitter<any>();
	onFileAlreadyRegisteredError: EventEmitter<any> = new EventEmitter<any>();
	onFileNameInvalidError: EventEmitter<any> = new EventEmitter<any>();
	onDocumentTypeInactiveError: EventEmitter<any> = new EventEmitter<any>();
	onDocumentTypeInvalidError: EventEmitter<any> = new EventEmitter<any>();
	onClientRelationshipInactiveError: EventEmitter<any> = new EventEmitter<any>();
	onClientRelationshipInvalidError: EventEmitter<any> = new EventEmitter<any>();
	onInactiveRecipientError: EventEmitter<any> = new EventEmitter<any>();
	onZeroByteFileError: EventEmitter<any> = new EventEmitter<any>();
	onInvalidRecipientShortNameError: EventEmitter<any> = new EventEmitter<any>();
	onInactiveSenderError: EventEmitter<any> = new EventEmitter<any>();
	onExportedFileNotFoundError: EventEmitter<any> = new EventEmitter<any>();
	onDirectoriesNotAllowedError: EventEmitter<any> = new EventEmitter<any>();
	onMultipleFilesNotAllowedError: EventEmitter<any> = new EventEmitter<any>();
	onFileNameInvalidCompressedFileError: EventEmitter<any> = new EventEmitter<any>();
	onRecipientShortNameNullError: EventEmitter<any> = new EventEmitter<any>();
	onActiveModalCloseConfirm: EventEmitter<any> = new EventEmitter<any>();
	onImportedFileIdNotFoundError: EventEmitter<any> = new EventEmitter<any>();
	onErrorWhileStagingError: EventEmitter<any> = new EventEmitter<any>();
	onInvalidCompressedFileError: EventEmitter<any> = new EventEmitter<any>();
	onInvalidClientError: EventEmitter<any> = new EventEmitter<any>();
	onServiceUnavailableError: EventEmitter<any> = new EventEmitter<any>();
	onInterfaceCreationError: EventEmitter<any> = new EventEmitter<any>();
	onUnauthorizedAccessToken: EventEmitter<any> = new EventEmitter<any>();
	onPrototypeIdError: EventEmitter<any> = new EventEmitter<any>();
	onLxnxPropsMissingError: EventEmitter<any> = new EventEmitter<any>();
	onLxnxPropsInvalidError: EventEmitter<any> = new EventEmitter<any>();
	onSupportedSchemaInvalidError: EventEmitter<any> = new EventEmitter<any>();
	onSupportedSchemaMissingError: EventEmitter<any> = new EventEmitter<any>();
	onDuplicateTenantNameError: EventEmitter<any> = new EventEmitter<any>();
	onClassificationError: EventEmitter<any> = new EventEmitter<any>();
	onAuthenticationSuccess: EventEmitter<any> = new EventEmitter<any>();
	onGetUserInfo: EventEmitter<any> = new EventEmitter<any>();
	onTokenExpiry: EventEmitter<any> = new EventEmitter<any>();
	onAccessDenied: EventEmitter<any> = new EventEmitter<any>();
	onMimeTypeMismatch: EventEmitter<any> = new EventEmitter<any>();
	onInvalidDataSourceJobPropsError: EventEmitter<any> = new EventEmitter<any>();
	onMissingDataSourcePropsError: EventEmitter<any> = new EventEmitter<any>();
	onImportFileNotInPendingStatus: EventEmitter<any> = new EventEmitter<any>();
	onFileUploadSystemError: EventEmitter<any> = new EventEmitter<any>();
	onSystemError: EventEmitter<any> = new EventEmitter<any>();
	onZeroByteCompressedFileError: EventEmitter<any> = new EventEmitter<any>();
	onReprocessedFileAlreadyRegisteredError: EventEmitter<any> = new EventEmitter<any>();
	onTenantNameError: EventEmitter<any> = new EventEmitter<any>();
	onReprocessedDuplicateFileContentError: EventEmitter<any> = new EventEmitter<any>();
	onLoginSuccess: EventEmitter<any> = new EventEmitter<any>();
	onKafkaConnectorError: EventEmitter<any> = new EventEmitter<any>();
	onFutureForecastModalError: EventEmitter<any> = new EventEmitter<any>();
	onPOClientConfigMissing: EventEmitter<any> = new EventEmitter<any>();
	onPOClientConfigValueMissing: EventEmitter<any> = new EventEmitter<any>();
	onInvalidPODataSourcePropsError: EventEmitter<any> = new EventEmitter<any>();
	onMissingPODataSourcePropsError: EventEmitter<any> = new EventEmitter<any>();
	onMissingDownloadRecordDelimiter: EventEmitter<any> = new EventEmitter<any>();
	onInvalidDownloadRecordDelimiter: EventEmitter<any> = new EventEmitter<any>();
	onMissingLegacyRMSBankId: EventEmitter<any> = new EventEmitter<any>();
	onInvalidLegacyRMSBankId: EventEmitter<any> = new EventEmitter<any>();
	onDuplicateLegacyRMSBankId: EventEmitter<any> = new EventEmitter<any>();
	onFileFormatInvalid: EventEmitter<any> = new EventEmitter<any>();
	onFileFormatMissing: EventEmitter<any> = new EventEmitter<any>();
	onMaintenanceRecordLengthMissing: EventEmitter<any> = new EventEmitter<any>();
	onPlacementRecordLengthMissing: EventEmitter<any> = new EventEmitter<any>();
	onXMLSchemaVersionMissing: EventEmitter<any> = new EventEmitter<any>();
	onInvalidFileName: EventEmitter<any> = new EventEmitter<any>();
	onStoragePropsBucketNameEmpty: EventEmitter<any> = new EventEmitter<any>();
	onStoragePropsObjectKeyPrefixEmpty: EventEmitter<any> = new EventEmitter<any>();
	onStoragePropsRegionEmpty: EventEmitter<any> = new EventEmitter<any>();
	onStoragePropsS3AccessKeyEmpty: EventEmitter<any> = new EventEmitter<any>();
	onStoragePropsS3SecretKeyEmpty: EventEmitter<any> = new EventEmitter<any>();
	onStoragePropsS3ServiceURLEmpty: EventEmitter<any> = new EventEmitter<any>();
	onConcatenationScheduleInvalid: EventEmitter<any> = new EventEmitter<any>();
	onConcatenatedFileNameUnmatchedBracesFBFIN: EventEmitter<any> = new EventEmitter<any>();
	onConcatenatedFileNameUnmatchedBracesFBMNT: EventEmitter<any> = new EventEmitter<any>();
	onConcatenatedFileNameUnmatchedBracesFBAUD: EventEmitter<any> = new EventEmitter<any>();
	onConcatenationFileNamesNotUnique: EventEmitter<any> = new EventEmitter<any>();
	onDPMProtoTypeNotDefinedError: EventEmitter<any> = new EventEmitter<any>();
	onDataRetentionPeriodInvalid: EventEmitter<any> = new EventEmitter<any>();
	onDataRetentionPeriodMissing: EventEmitter<any> = new EventEmitter<any>();
	onFormatBFileSizeError: EventEmitter<any> = new EventEmitter<any>();
	onDuplicateBatchId: EventEmitter<any> = new EventEmitter<any>();
	onFileNotFoundError: EventEmitter<any> = new EventEmitter<any>();
	onPassthroughFilesDisabled: EventEmitter<string> = new EventEmitter<string>();
	onInactiveClientError: EventEmitter<any> = new EventEmitter<any>();
	onInterfaceCodeExistInSameRelationshipError: EventEmitter<any> = new EventEmitter<any>();
	onTransactionAlreadyExistError: EventEmitter<any> = new EventEmitter<any>();
	onFileDataAlreadyExistError: EventEmitter<any> = new EventEmitter<any>();
	onInvalidIPAddressRange: EventEmitter<any> = new EventEmitter<any>();
	onDuplicateRateTier: EventEmitter<any> = new EventEmitter<any>();
	onDuplicateRateCode: EventEmitter<any> = new EventEmitter<any>();

}
